import React from 'react';
import classNames from 'classnames';

export default function Content({ className, ...props }) {
  return (
    <div className={classNames('content', className)} {...props} />
  );
}